module.exports = __webpack_public_path__ + "bh.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bh.svg
// module id = 447
// module chunks = 0